/**************************************************
 * Nombre:       Tarjeta_Tipo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import {KeyboardArrowRight} from "@mui/icons-material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {contarWheres} from "../../Servicios/BD/Contadores/contarWheres";
import {where} from "firebase/firestore";

const Tarjeta_Tipo = ({item}) => {
    const {sCell} = useResponsive()
    const [numero, setNumero] = useState(0);

    useEffect(() => {

        let w = [where('tipo', '==', item.nombre)]
        contarWheres({coleccion: 'productos', wheres: w}).then((dox) => {
            if (dox.res) {
                setNumero(dox.data)
            }
        })

    }, [item])
    return (
        <Grid
            container
            justifyContent={'flex-end'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{

                backgroundImage: `url(${item.img})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: sCell ? '300px 120px' : '300px 121px',
                backgroundPosition: 'center',
                transition: 'all .2s ease-in-out',
                borderRadius: sCell ? 0 : 50,
                color: '#fff',
                px: 4,
                py: 3,
                cursor: 'pointer',
                "&:hover": {
                    backgroundSize: '318px 130px',

                }
            }}
        >

            <Grid container size={{xs: 5, sm: 5, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 16, fontWeight: 600}}>
                            {item.nombre}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 14, fontWeight: 300}}>
                            {`${numero} Productos`}
                        </Typography>
                    </Grid>


                </Grid>
            </Grid>


            <Grid container size={{xs: 2, sm: 2, md: 1}} sx={{justifyContent: 'flex-start'}}>
                <IconButton sx={{backgroundColor: '#fff'}}>
                    <KeyboardArrowRight sx={{fill: '#000'}}/>
                </IconButton>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Tipo